import React, { useState } from 'react'
import { Button, Col, Form, Input, Row, Space, Alert } from 'components/common'
import { PrefectureSelect } from '../PrefectureSelect'
import { convertPrefCode } from 'helper'

export interface AddressAndDetailsFormProps {
  form
  defaultValues?: {
    address1?: string
    address2?: string
    city?: string
    prefectureCode?: string
    zip?: string
  }
}

export const AddressAndDetailsForm = ({
  form,
  defaultValues = {},
}: AddressAndDetailsFormProps): JSX.Element => {
  const [isLoading, setIsLoading] = useState(false)

  const { address1, address2, city, prefectureCode, zip } = defaultValues
  const [zipData, setZipData] = useState<any>({
    prefectureCode: prefectureCode,
    city: city,
    address1: address1,
    address2: address2,
  })

  const [errorMessage, setErrorMessage] = useState<string | null>(null) // エラーメッセージのステート

  const onSearch = async () => {
    setIsLoading(true)
    const currentZip = form.getFieldValue('zip')
    if (!currentZip) return

    const response = await fetch(
      `https://zipcloud.ibsnet.co.jp/api/search?zipcode=${currentZip}`
    )
    const data = await response.json()

    if (data?.results && data.results.length > 0) {
      const { address2, prefcode } = data.results[0]

      const newZipData = {
        prefectureCode: convertPrefCode(prefcode),
        city: address2,
      }
      setZipData(newZipData)

      // フォームのフィールド値を更新
      form.setFieldsValue({
        prefectureCode: newZipData.prefectureCode,
        city: newZipData.city,
      })
      setErrorMessage(null) // エラーメッセージをクリア
    } else {
      const emptyData = {
        prefectureCode: null,
        city: '',
      }
      setZipData(emptyData)

      // フォームのフィールド値をクリア
      form.setFieldsValue({
        prefectureCode: emptyData.prefectureCode,
        city: emptyData.city,
      })
      setErrorMessage('該当する住所データが見つかりませんでした。') // エラーメッセージをセット
    }
    setIsLoading(false)
  }

  return (
    <>
      {/* エラーメッセージを表示 */}
      {errorMessage && <Alert message={errorMessage} type="error" />}{' '}
      <Row>
        <Space>
          <Col>
            <Form.Item
              name={'zip'}
              label="郵便番号"
              labelCol={{ span: 24 }}
              initialValue={zip}
              rules={[
                {
                  required: true,
                },
                {
                  pattern: /^\d{7}$/,
                  message: '郵便番号は7桁の数字を入力してください。',
                },
              ]}
            >
              <Input autoComplete="off" />
            </Form.Item>
          </Col>
          <Col>
            <Button onClick={onSearch} loading={isLoading}>
              住所検索
            </Button>
          </Col>
        </Space>
      </Row>
      <PrefectureSelect
        required
        value={zipData.prefectureCode}
        defaultValue={zipData.prefectureCode}
      />
      <Form.Item
        name={'city'}
        label="市区町村"
        labelCol={{ span: 24 }}
        initialValue={zipData.city}
        rules={[
          { required: true },
          {
            type: 'string',
            max: 32,
          },
        ]}
      >
        <Input />
      </Form.Item>
      <Form.Item
        name="address1"
        label="住所"
        labelCol={{ span: 24 }}
        initialValue={zipData.address1}
        rules={[
          { required: true },
          {
            type: 'string',
            max: 64,
          },
        ]}
      >
        <Input autoComplete="off" />
      </Form.Item>
      <Form.Item
        name="address2"
        label="建物名、部屋番号など"
        labelCol={{ span: 24 }}
        initialValue={zipData.address2}
        rules={[
          {
            type: 'string',
            max: 64,
          },
        ]}
      >
        <Input autoComplete="off" />
      </Form.Item>
    </>
  )
}
